export const selectBureauReport = state => state.bureauReports;
export const selectBureauReportList = state => selectBureauReport(state).items;
export const selectBureauReportListCount = state => selectBureauReport(state).count;
export const selectBureauReportQueryOptions = state => {
  const { options } = selectBureauReport(state);

  Object.keys(options).forEach(key => {
    if (options[key] === '') {
      delete options[key];
    }
  });

  return options;
};

export const selectBureauReportDetail = state => state.bureauReportDetail;
export const selectBureauReportDetailList = state => selectBureauReportDetail(state).items;
export const selectBureauReportDetailCount = state => selectBureauReportDetail(state).count;
export const selectBureauReportDetailInfo = state => selectBureauReportDetail(state).reportInfo;
export const selectBureauReportDetailPage = state => selectBureauReportDetail(state).currentPage;
export const selectBureauReportDetailSearchParams = state => selectBureauReportDetail(state).searchParams;
